import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { NavController, App, ActionSheetController } from 'ionic-angular';
import { AuthProvider } from '@providers/auth/auth';
import { MenuProvider } from '@providers/menu/menu';
import { Jugador } from '@domain/jugador';
import { DesafioPersonalProvider } from '@providers/desafio-personal/desafio-personal';
import { PerfilPage } from '@pages';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageViewerController } from 'ionic-img-viewer';
import { Equipo } from '@domain/equipo';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController } from 'ionic-angular';
import { ColorProvider } from '@providers/color/color';
import { Events } from 'ionic-angular';

@Component({
  selector: 'user-info',
  templateUrl: 'user-info.html'
})
export class UserInfoComponent implements OnInit, AfterViewInit {

  jugador: Jugador = new Jugador;
  equipo: Equipo = new Equipo;
  score: number = 0;
  avatar: any = {
    mime: '',
    avatar: '',
  };
  _imageViewerCtrl: ImageViewerController;
  myAvatar: string;
  @ViewChild('header', { read: ElementRef }) header: ElementRef;
  areasJugador: Array<any> = [];
  primaryColor: string;

  constructor(public navCtrl: NavController,
    public sanitizer: DomSanitizer,
    private authProvider: AuthProvider,
    private app: App,
    private imageViewerCtrl: ImageViewerController,
    private desafioPersonalProvider: DesafioPersonalProvider,
    private menuProvider: MenuProvider,
    private translate: TranslateService,
    public actionSheetCtrl: ActionSheetController,
    public loadingCtrl: LoadingController,
    public colorProvider: ColorProvider,
    private events: Events
  ) {

  }

  async ngOnInit() {
    await this.getScore();
  }

  async ngAfterViewInit() {
    this.updateColors();
    this.events.subscribe('color:updated', async () => {
      this.updateColors();
    });
  }

  async updateColors() {
    this.primaryColor = await this.colorProvider.getPrimaryColor();
    this.header.nativeElement.style.backgroundImage = await this.colorProvider.renderHeaderBG();
  }

  showAvatar(avatar) {
    if(this.myAvatar) {
      const img = document.createElement('img');
      img.src = this.myAvatar;

      this._imageViewerCtrl = this.imageViewerCtrl;
      const imageViewer = this._imageViewerCtrl.create(img);
      imageViewer.present();
    }
  }

  refreshAvatar() {
    this._imageViewerCtrl = null;
  }

  async getScore() {
    await this.authProvider.getSession()
      .then(jugador => {
        this.jugador = jugador;
        return this.authProvider.getAvatar();
      })
      .then(avatar => {
        this.avatar = avatar;
        this.myAvatar = `data:${this.avatar.mime};base64,${this.avatar.avatar}`;
        return this.authProvider.getEquipo();
      })
      .then( equipo => {
        this.equipo = equipo;
        return this.authProvider.getScorePersonal();
      })
      .then(score => {
        this.score = score;
        return this.desafioPersonalProvider.score(this.jugador._id, this.equipo.area._id);
      })
      .then(response => {
        this.score = response.score;
        this.authProvider.saveScorePersonal(response.score);
      });

      this.areasJugador = await this.authProvider.getAreasJugador(this.jugador._id);
  }

  bypassSecurityTrustResourceUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  updateScore() {
    return this.authProvider.getScorePersonal()
      .then(score => {
        this.score = score;
        return this.desafioPersonalProvider.score(this.jugador._id, this.equipo.area._id);
      })
      .then(response => {
        this.score = response.score;
        this.authProvider.saveScorePersonal(response.score);
      });
  }

  verPerfil() {
    this.app.getRootNavs()[0].push(PerfilPage);
  }

  openMenu() {
    this.menuProvider.setStatus(true);
  }

  async setArea() {
    this.areasJugador = await this.authProvider.getAreasJugador(this.jugador._id);
    
    let areas: any = this.areasJugador.map( e =>  {
      return {
        text: e.area.nombre,
        cssClass: e._id == this.equipo._id ? 'gameif-active-area': '',
        handler: () => {
          this._cambiaArea(e._id);
        }
      };
    });
    areas.push({
      text: this.translate.instant('perfil.cambiarArea.cancel'),
      role: 'cancel',
      cssClass: 'color-danger-as'
    });

    const actionSheet = this.actionSheetCtrl.create({
      // title: this.translate.instant('perfil.cambiarArea.areas'),
      buttons: areas,
      cssClass: 'gameif-action-sheet'
    });

    actionSheet.present({ animate: false }).then( x => {
      const actionSheetContainer: any = document.querySelector('.gameif-action-sheet .action-sheet-container');
      actionSheetContainer.style.opacity = '1';

      const actionSheetGroup: any = document.querySelectorAll('.gameif-action-sheet .action-sheet-group');
      actionSheetGroup.forEach(element => {
        element.style.background = this.primaryColor;  
      });
    });
  }

  private _cambiaArea(equipoId) {
    let equipo = this.areasJugador.find( e => e._id ==  equipoId);

    if( this.equipo._id != equipo._id ){
        this.equipo = equipo;
        this.authProvider.saveEquipo(equipo);

        const loader = this.loadingCtrl.create({
           content: "Please wait...",
        });
        loader.present();
        this.authProvider.changeArea(true);
        setTimeout( () => window.location.reload(true), 500);

    }
  }
}



// WEBPACK FOOTER //
// ./src/components/user-info/user-info.ts